<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="54" height="33" viewBox="0 0 54 33">
    <defs>
        <path id="kuntvlwypb" d="M0 0L21.363 0 21.363 20.484 0 20.484z"/>
        <path id="vcuclxr0kd" d="M0 0L21.363 0 21.363 20.484 0 20.484z"/>
        <path id="3r4ih2c0if" d="M0 0L21.363 0 21.363 20.484 0 20.484z"/>
        <linearGradient id="2ygg9n87ia" x1="0%" x2="100%" y1="68.673%" y2="31.327%">
            <stop offset="0%" stop-color="#0168B4"/>
            <stop offset="18.838%" stop-color="#0168B4"/>
            <stop offset="50.596%" stop-color="#B8383C"/>
            <stop offset="100%" stop-color="#D90338"/>
        </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <g>
            <g>
                <path fill="url(#2ygg9n87ia)" d="M1 0h52c.552 0 1 .448 1 1v31c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1z" transform="translate(-5 -8) translate(5 8) matrix(-1 0 0 1 54 0)"/>
                <g transform="translate(-5 -8) translate(5 8) translate(15 5)">
                    <path fill="#FFF" d="M14 12c0 .829-.67 1.5-1.5 1.5S11 12.829 11 12s.67-1.5 1.5-1.5 1.5.671 1.5 1.5" transform="rotate(-180 12.5 12)"/>
                    <path fill="#FFF" d="M13.934 14.173c-1.36-.936-3.28-.857-4.16 0-.837.816.497 2.195.63 2.327.289-.281.689-.456 1.13-.456.32 0 .618.092.869.25l.011-.017c.56-.78 1.36-.935 1.36-.935s1.52-.234.16-1.17" transform="rotate(-180 12 15)"/>
                    <path fill="#FFF" d="M13.512 9.482c-.14 1.845.941 3.638 2.189 3.983 1.187.329 1.748-1.749 1.799-1.95-.41-.114-.78-.397-1.013-.82-.168-.306-.24-.645-.227-.976h-.022c-1.008-.086-1.571-.761-1.571-.761s-1.013-1.32-1.155.524" transform="rotate(-180 15.5 11)"/>
                    <path fill="#FFF" d="M11.934 9.173c-1.36-.936-3.28-.857-4.16 0-.837.816.497 2.195.63 2.327.289-.281.689-.456 1.13-.456.32 0 .618.092.869.25l.011-.017c.56-.78 1.36-.935 1.36-.935s1.52-.234.16-1.17" transform="rotate(-60 10 10)"/>
                    <g transform="rotate(-180 12 11.5)">
                        <mask id="ylngp4b9rc" fill="#fff">
                            <use xlink:href="#kuntvlwypb"/>
                        </mask>
                        <path fill="#FFF" d="M21.363 0L15.19 5.915c-1.047-.96-2.417-1.536-3.908-1.536-3.336 0-6.044 2.884-6.044 6.44 0 1.346.387 2.6 1.056 3.63L0 20.484V0h21.363z" mask="url(#ylngp4b9rc)"/>
                    </g>
                    <g transform="translate(1.5 1.5)">
                        <mask id="1xx5u1y7ye" fill="#fff">
                            <use xlink:href="#vcuclxr0kd"/>
                        </mask>
                        <path fill="#FFF" d="M21.363 0L15.19 5.915c-1.047-.96-2.417-1.536-3.908-1.536-3.336 0-6.044 2.884-6.044 6.44 0 1.346.387 2.6 1.056 3.63L0 20.484V0h21.363z" mask="url(#1xx5u1y7ye)"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
